import { VisitorID } from './components/visitor-id.js';
import { getBrowserType } from "./core/utils.js";
import { checkNewTabButtonTarget } from "./components/cta-new-tab.js";
import { initCampaign } from "./components/journey-tracker.js";
import { waba } from "./components/waba-trigger.js";
import { checkChannelParams } from "./components/channel-params.js";
import { initCTAPartner } from "./components/cta-partner.js";
import { initWabaTracking } from "./components/utm-tracker.js"; // <--- tambahkan ini
import { ContactAutoTrack } from './components/auto-contact-track.js';
import { cta_trial_locale } from './components/cta-trial-locale.js';

// NOTE: This entrypoint doesn't require jQuery.
// Avoid wrapping in (function($){...})(jQuery) because some pages may load/define jQuery late
// (or not at all), which would prevent the whole bundle from executing.
(function () {
  'use strict';

  const visitorID = VisitorID.init();
  console.log('Current Visitor ID:', visitorID);

  function checkStickyWABA() {
    var stickyWABA = document.querySelector('.ic-wa');
    if(!stickyWABA) {
      var scrollTop = document.querySelector('#scroll-top');
      if(scrollTop) {
        scrollTop.classList.add('alt');
      }
    }
  }

  // Bind WABA handlers as early as possible so dynamically opened modals
  // can be clicked immediately even if tracking init is still in-flight.
  try { waba(); } catch (e) {}

  initWabaTracking({
    csv: {
      mediumUrl: document.querySelector('#medium_file')?.value || '',
      campaignUrl: document.querySelector('#campaign_file')?.value || ''
    },
    ttlDays: 31,
    debug: false,
    channelCodes: {
      medium:   { 'organic direct': 'J7O', 'organic search': 'J6O' },
      campaign: { 'default': 'MJ' }
    }
  }).then(({ code, ccode, updated, source }) => {
      // console.log('WABA:', code, ccode, updated, source);

      checkStickyWABA();
      getBrowserType();
      checkNewTabButtonTarget();
        // Safe if called multiple times; handler is idempotent.
        waba();
      initCampaign();
      checkChannelParams();
      initCTAPartner();
      cta_trial_locale();
  });

  ContactAutoTrack.init();  

  

})();